export enum viewport {
  desktop = 1200,
}
